import styled from "styled-components";

const StyledHelp = styled.p`
    font-size: ${props => props.theme.text.heading4.sizeRem};
    margin-top: 0.5em;
    color: ${props => props.theme.colours.flat.darkGray.hex};
`;

export default StyledHelp;
